import { Box, Heading } from '@zillow/constellation-10';
import { FolderSelector } from '@zg-rentals/satellite-components';
import { useAuth } from '../../AuthProvider';
import React, { useContext } from 'react';
import { InboxPageMobileView } from '../../types/InboxPageMobileView';
import { emitStarredConversationsFilterEvent } from '../../constants/clickstreamEvents/starConversations';
import { emitOpenFilterMenuEvent, OPEN_FILTER_MENU_EVENT_TYPE_ID } from '../../constants/clickstreamEvents/filterMenu';
import { InboxPageContext } from '../../contexts/InboxPageContextProvider';
import FiltersSelector from '../FiltersSelector';
import { foldersSelectorContainerStyles, headerContainerStyles, headingStyles } from './styles';
import {
  SatelliteConversationFolderTypeV2,
  SatelliteConversationReadRepliedStatusTypeV2,
  SatelliteConversationRenterProgressStatusTypeV2,
} from '@zg-rentals/ts-satellite-client';
import useInboxRouterHelper from '../../hooks/useInboxRouterHelper';
import useDevices from '../../hooks/useDevices';

/**
 * This component contains all the content above the messaging portion of Inbox Page
 * such as the read filters, folders, and Rental Journey filters
 */
export default function InboxHeader() {
  const { folder: currentFolder, mobileView } = useContext(InboxPageContext);
  const { changeFiltersOrFolders } = useInboxRouterHelper();
  const { user } = useAuth();
  const { isMobileView } = useDevices();

  const shouldHideHeaderOnMobile = mobileView !== InboxPageMobileView.ConversationList && isMobileView;

  const handleFolderChange = (selectedOption: SatelliteConversationFolderTypeV2) => {
    if (selectedOption === SatelliteConversationFolderTypeV2.FAVORITE) {
      emitStarredConversationsFilterEvent(user);
    }

    if (selectedOption !== currentFolder) {
      changeFiltersOrFolders({
        folder: selectedOption,
        // Reset all other filters
        renterProgressStatus: SatelliteConversationRenterProgressStatusTypeV2.SHOW_ALL,
        readRepliedStatus: SatelliteConversationReadRepliedStatusTypeV2.SHOW_ALL,
        byProperty: false,
      });
    }
  };

  const handleMenuOpen = () => {
    emitOpenFilterMenuEvent(user);
  };

  return (
    <Box
      css={{
        ...headerContainerStyles,
        display: shouldHideHeaderOnMobile ? 'none' : 'flex',
      }}
    >
      <Heading level={1} fontFamily="heading-alt" css={headingStyles}>
        Messages
      </Heading>

      {/* Desktop: Filters button */}
      <Box
        css={{
          display: { base: 'none', xxl: 'block' },
          marginLeft: 'auto',
        }}
      >
        <FiltersSelector />
      </Box>

      {/* Inbox button - always last on row 1 */}
      <Box css={foldersSelectorContainerStyles} data-eventid={OPEN_FILTER_MENU_EVENT_TYPE_ID}>
        <FolderSelector
          actions={{ onFolderChange: handleFolderChange, onMenuOpen: handleMenuOpen }}
          selectedFolder={currentFolder}
        />
      </Box>
    </Box>
  );
}
